<template>
  <div class="top-margin">
    <form v-on:submit.prevent="reset">
      <input type="password" name="password" v-model="password" placeholder="New Password" />
      <input type="password" name="confirm-password" v-model="confirmPassword" placeholder="Confirm Password" />
      <div class="error" v-if="errors">{{ errors }}</div>
      <button type="submit" class="full-width primary">Reset</button>
    </form>
  </div>
</template>

<script>
import { api } from "@monolith/helpers";

export default {
  name: "PasswordReset",
  data() {
    return {
      password: null,
      confirmPassword: null,
      errors: null
    }
  },
  methods: {
    async reset() {
      if (this.password != this.confirmPassword) {
        return this.errors = "Passwords do not match";
      }
      const res = await api.updatePass(this.$route.params.token, this.password)
      if (res === 'ok') {
        this.$router.push('/');
      } else {
        this.errors = "There was an error resetting your password";
      }
    }
  }
}
</script>

<style scoped lang="scss">
form {
  border-radius: 0.5rem;
  max-width: 400px;
  padding: 2rem;
  margin: 0px auto;
  margin-top: 1rem;
  background-color: var(--secondary-colour);

  input, button { font-size: 1rem; border: none; }
  input { box-sizing: border-box; padding: 1em; width: 100%; margin-bottom: 1rem; }
}

form div.error {
  color: #ff8197;
  margin-bottom: 1em;
}
</style>
